<script lang="ts" setup>
import { type Image, type Link } from '../types/types';
import { ref, onMounted, onUnmounted } from 'vue';
import Splide from '@splidejs/splide';

const props = defineProps<{
    title: string,
    subtitle: string,
    images: {
        link: Link,
        image: Image
    }[] | null,
    sliderId: string,
    addBackgroundColor: boolean
}>();

  const splideRef = ref<HTMLElement | null>(null);
  let splideInstance = null
  
  const splideOptions = {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '2rem',
    padding: '3px',
    arrows: true,
    pagination: false,
    autoWidth: false,
    breakpoints: {
      768: {
        perPage: 1,
        gap: '1rem',
        arrows: false
      },
      1024: {
        perPage: 2,
        gap: '1.5rem',
      },
    },
  }
  
  const goPrev = () => {
    if (splideInstance) {
      splideInstance.go('<')
    }
  }
  
  const goNext = () => {
    if (splideInstance) {
      splideInstance.go('>')
    }
  }
  
  onMounted(() => {
    if (splideRef.value) {
      splideInstance = new Splide(splideRef.value, splideOptions)
      splideInstance.mount()
    }
  })
  
  onUnmounted(() => {
    if (splideInstance) {
      splideInstance.destroy()
    }
  })
</script>
<template>
    <div :class="`box-slider-wrapper ${addBackgroundColor ? 'bg-green-light' : ''}`">
        <div class="container-xl">
            <div :class="`slider-header ${!images ? 'mb-0' : ''}`">
                <h2 :class="`slider-title ${addBackgroundColor ? 'text-white' : 'text-dark-2'}`">{{ title }}</h2>
                <h4 :class="`slider-subtitle ${addBackgroundColor ? 'text-white' : 'text-primary'} ff-dm-sans-light mb-0`">{{ subtitle }}</h4>
            </div>
        </div>
        <div v-if="images" class="slider-container">
            <div class="container-xl">
                <div ref="splideRef" class="splide" :options="splideOptions" :id="sliderId">
                    <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide" v-for="(item, index) in images" :key="index">
                        <div class="slide-content">
                            <div class="slide-image">
                            <NuxtImg v-if="item?.image?.node?.mediaItemUrl" :alt="item?.image?.node?.title" :src="item?.image?.node?.mediaItemUrl" loading="lazy" format="webp" :quality="80" :srcset="item?.image?.node?.srcSet"/>
                            </div>
                            <div class="action-div w-100 d-flex pb-2">
                                <a target="_blank" :href="item?.link?.url" :class="`rounded-pill text-uppercase btn ${addBackgroundColor ? 'btn-white' : 'btn-secondary'} `">{{ item?.link?.title }}</a>
                            </div>
                        </div>
                        </li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>